export const formatDecimalNumber = (numberValue: number) => {
	return Math.round((numberValue + Number.EPSILON) * 100) / 100;
};
